import { queryOptions, useQuery } from '@tanstack/react-query';

import { marketsApi } from '../api/markets-api';

import { marketKeys } from './market-keys';

export function marketsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: marketKeys.list(storeId),
    queryFn: () => marketsApi.list(storeId),
  });
}

export function useMarkets(storeId: string) {
  return useQuery(marketsQueryOptions(storeId));
}
